
import AppSelectView from "@/components/browse/SelectView.vue";
import AppQuickSearch from "@/components/browse/BrowseQuickSearch.vue";
import {IBrowseDataSource} from "@/utils/browse/browse-data-source";
import {BrowseState} from "@/utils/browse/browse-state";
import {IQueryParams} from "@/utils/query-params";
import Vue from "vue";
import {UserConfigService} from "@/services/user-config-service";
import AppReportsDropdown from "./BrowseReportsDropdown.vue";
//import AppBrowseSettingsDropdown from "./BrowseSettingsDropdown.vue";
import {ISelectItem} from "winfakt-vue-components/src/classes";
import {Sale} from "@/models/base";
import AppTag from "@/components/common/Tag.vue";
import {CustomButton} from "@/utils/buttons/custom-button";
import AppCustomButtonModal from "@/components/browse/CustomButtonModal.vue";
import { BROWSE_BUTTONS, BrowseButton } from "@/models/user-configs/browse-permissions";

export default Vue.extend({
	props: {
		state: {
			required: true,
			type: Object as () => BrowseState
		}
	},
	computed: {
		visibleCustomButtons(): CustomButton[] {
			return this.state.getVisibleCustomButtons();
		},
		customButtonsStart(): CustomButton[] {
			return this.visibleCustomButtons.filter(btn => btn.Position == "start");
		},
		customButtonsEnd(): CustomButton[] {
			return this.visibleCustomButtons.filter(btn => btn.Position != "start");
		},
		editButtonBarVisible(): boolean {
			if (this.state.editButtonsHidden) {
				return false;
			}
			if (this.$wf.isMdDown || this.visibleCustomButtons.length > 0) {
				return true;
			}
			return BROWSE_BUTTONS.some(button => !this.isButtonHidden(button));
		},
		browseName() {
			let t = this.$ct("single-browse-name." + this.state.browse.ID).toString();
			return t ? t : this.$ct("item").toString();
		},
		addRoute(): string {
			if (typeof (this.dataSource.addRoute) == "string") {
				return this.dataSource.addRoute;
			}
			return this.dataSource.addRoute(this.state.querySettings.view);
		},
		selectedItems(): any[] {
			return this.state.selectedItems;
		},
		itemSelected(): boolean {
			return this.state.selectedItems.length == 1;
		},
		itemsSelected(): boolean {
			return this.state.selectedItems.length > 0;
		},
		querySettings(): IQueryParams {
			return this.state.querySettings;
		},
		controlsDisabled(): boolean {
			return this.state.controlsDisabled;
		},
		searchEnabled(): boolean {
			return this.state.searchEnabled;
		},
		displayedSearchVal(): string {
			return (this.querySettings.searchQuery || "").replace(/^%/, "");
		},
		dataSource(): IBrowseDataSource<any> {
			return this.state.dataSource;
		},
		buttonBarItems(): ISelectItem<string | Function>[] {
			return this.state.getButtonBarItems();
		},
		addDisabled(): boolean {
			if (!this.canWrite) {
				return true;
			}
			if (this.dataSource.canCreate !== undefined) {
				return !this.dataSource.canCreate || false;
			}
			return false;
		},
		editDisabled(): boolean {
			if (!this.itemsSelected) {
				return true;
			}
			if (!this.itemSelected && !this.dataSource.batchEdit) {
				return true;
			}
			if (!this.canWrite) {
				return true;
			}
			if (this.dataSource.canEdit != undefined && !this.dataSource.canEdit(this.selectedItems[0])) {
				return true;
			}
			return false;
		},
		duplicateDisabled(): boolean {
			if (!this.itemSelected) {
				return true;
			}
			if (!this.canWrite) {
				return true;
			}
			if (this.dataSource.canDuplicate != undefined) {
				return !this.dataSource.canDuplicate(this.selectedItems[0]);
			}
			if (this.dataSource.canEdit != undefined && !this.dataSource.canEdit(this.selectedItems[0])) {
				return true;
			}
			return false;
		},
		deleteDisabled(): boolean {
			if (!this.itemsSelected) {
				return true;
			}
			if (!this.canDelete) {
				return true;
			}
			if (this.dataSource.canDelete) {
				return !this.dataSource.canDelete(this.selectedItems);
			}
			return false;
		},


		canWrite(): boolean {
			return UserConfigService.hasCurrentUserPermission((p) => this.dataSource.browsePermissions().hasWritePermissions());
		},
		canDelete(): boolean {
			return UserConfigService.hasCurrentUserPermission((p) => this.dataSource.browsePermissions().hasDeletePermissions());
		},
		canView(): boolean {
			return this.itemSelected;
		},
		isFetching(): boolean {
			return this.state.fetching;
		}

	},

	methods: {
		isButtonHidden(button: BrowseButton): boolean {
			return this.state.isButtonHidden(button);
		},
		deleteClicked() {
			this.state.delete();
		},
		startSearch(val: string) {
			this.state.selectedItems.splice(0, this.state.selectedItems.length);
			this.state.querySettings.searchQuery = val;
			this.state.fetch();
		},
		searchClicked() {
			//this.$emit("search");
		},
		trigger(value: string | Function) {
			console.log("trigger", value, typeof(value));
			if (typeof (value) == "function") {
				value();
				return;
			}
			this.state.buttonBarItemTrigger(value);
		},
		clearSearchQuery() {
			let filters = this.state.getFilters();
			filters.searchQuery = "";
			filters.filters = [];
			this.state.setFilters(filters);
			this.state.fetch();
		},
		clearFilters() {
			let filters = this.state.getFilters();
			filters.filters = [];
			this.state.setFilters(filters);
			this.state.fetch();
		},
		emptySelectedItems() {
			this.state.emptySelectedItems();
		},
		editClicked() {
			if (this.validateSaldoDocuments()) {
				return;
			}
			this.state.edit();
		},
		duplicateClicked() {
			if (this.validateSaldoDocuments()) {
				return;
			}
			this.state.duplicate();
		},
		infoClicked() {
			if (this.validateSaldoDocuments()) {
				return;
			}
			if (this.dataSource.info) {
				this.dataSource.info(this.state.selectedItems[0]);
			}
		},
		validateSaldoDocuments(): Boolean {
			if (this.state.browse.ID == 6) {
				if (this.state.selectedItems[0] && (this.state.selectedItems[0] as Sale).isSaldoDocument()) {
					this.$wf.dialog(this.$ct("saldo-warning"), this.$ct("common.Ok"), this.$ct("common.attention"), "info");
					return true;
				}
			}
			return false;
		},
		async refresh() {
			await this.state.fetch();
		},
	},
	components: {
		AppSelectView,
		AppQuickSearch,
		AppReportsDropdown,
		//AppBrowseSettingsDropdown,
		AppTag,
		AppCustomButtonModal
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
